import React from 'react';
import Image from '../../../atoms/Image';
import check from '../data/check.png';

export default ({ title, description }) => (
  <div>
    <Image src={check} className="checkmark" size="small" />
    <h1 className="modal-header centered-content">{title}</h1>
    <p className="centered-content body-text blue-color">{description}</p>
  </div>
);
